import { create } from 'zustand'
import { platform, type InstallAvailability } from '@/platform'
import { INSTALL_DISMISS_KEY } from '@/lib/install-policy'

export { shouldShowInstallPrompt } from '@/lib/install-policy'

/* Spec PWA-001 — FR-031: estado do convite de instalacao (regras puras em lib/install-policy.ts). */

type InstallState = {
    availability: InstallAvailability
    dismissedAt: string | null
    /* Aviso flutuante visivel agora (o cartao do Inicio se esconde para nao repetir o convite) */
    floatingVisible: boolean
    setFloatingVisible: (visible: boolean) => void
    refresh: () => void
    dismiss: () => void
    install: () => Promise<boolean>
}

export const useInstallStore = create<InstallState>((set) => ({
    availability: platform.install.availability(),
    dismissedAt: platform.storage.get(INSTALL_DISMISS_KEY),
    floatingVisible: false,
    setFloatingVisible: (floatingVisible) => set({ floatingVisible }),
    refresh: () => set({ availability: platform.install.availability() }),
    dismiss: () => {
        const at = String(Date.now())
        platform.storage.set(INSTALL_DISMISS_KEY, at)
        set({ dismissedAt: at })
    },
    install: async () => {
        const accepted = await platform.install.prompt()
        set({ availability: platform.install.availability() })
        return accepted
    },
}))

platform.install.subscribe(() => useInstallStore.getState().refresh())
